import { canOpenQuickStart, helpOwner } from "./contextualHelp";
import { helpContent } from "./content";
import { publishedContent } from "./manifest";

export const signupPurposes = [
  {
    value: "SAVE_TIME_MARKING",
    title: "Save time marking",
    description: "Review marks and useful feedback on students’ answers.",
    icon: "marking",
    guide: "marked-answer",
  },
  {
    value: "UNDERSTAND_CLASS_PERFORMANCE",
    title: "Understand class performance",
    description: "Identify strengths, gaps and what to teach next.",
    icon: "performance",
    guide: "class-insights",
  },
  {
    value: "CREATE_QUIZZES_RESOURCES",
    title: "Create quizzes and resources",
    description: "Build activities and check students’ understanding.",
    icon: "quiz",
    guide: "first-quiz",
  },
  {
    value: "EXPLORE_FOR_SCHOOL",
    title: "Explore Fruitify for my school",
    description:
      "Connect your MIS through Wonde, reduce admin and explore insights across classes and departments.",
    icon: "school",
    guide: "class-insights",
  },
];

export const canOpenIntroduction = (user) =>
  canOpenQuickStart(user) && !user?.beingImpersonated;

export function shouldShowSignupPurpose(
  user,
  onboarding,
  { blocked = false, pathname = "/", panel = null } = {},
) {
  return Boolean(
    canOpenIntroduction(user) &&
      user.signInSession &&
      !user.introductionSeen &&
      onboarding?.eligible &&
      onboarding.status === "PENDING" &&
      !blocked &&
      !panel &&
      // Offer on the landing dashboard, never interrupt a deep link or ongoing work.
      ["/", "/dashboard"].includes(pathname),
  );
}

export function purposeGuide(purpose) {
  const id =
    signupPurposes.find((item) => item.value === purpose)?.guide ||
    "first-answer";
  return publishedContent(helpContent).find((guide) => guide.id === id);
}

export const introductionOwner = (user) =>
  `${helpOwner(user)}:${user?.signInSession || "legacy"}`;
